import Footer from 'navigation/footer';
import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import styled from 'styled-components';

import { Header } from './components/molecules/Header';
import { AuthProvider } from './hooks/auth-context';
import { AxiosProvider } from './hooks/axios-context';
import { UserProvider } from './hooks/user-context';
import { Routes } from './navigation';

import './styles/App.css';

export const App: React.FC = () => {
  return (
    <AxiosProvider>
      <AuthProvider>
        <UserProvider>
          <Router>
            <AppWrapper>
              <Header />
              <Routes />
              <Footer />
            </AppWrapper>
          </Router>
        </UserProvider>
      </AuthProvider>
    </AxiosProvider>
  );
};

const AppWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-x: hidden;
`;

export default App;
